module.exports = __webpack_public_path__ + "media/app/components/Footer/AppStore.5dad41a2.svg";